/* wb-product-reviews-translate.js — les avis traduits à l'affichage, comme le faisait
   le widget Judge.me (01/10/2026).
   Copie de référence du dépôt parent : l'original déployé est
   `assets/wb-product-reviews-translate.js` du thème live (en cas de doute le thème live
   fait foi). Chargé en `defer` par `sections/wb-product-reviews.liquid`.

   Judge.me est réglé en traduction automatique (`widget_translate_review_content_method`
   = `automatic`) : son widget traduisait à l'écran un avis d'une autre langue que la
   page, par une traduction stockée, sinon le traducteur du navigateur, sinon son
   service `api/review_translations` (`ReviewItem-*.js`). La section et le script des
   avis n'affichent que les traductions STOCKÉES : sans ce fichier, un avis jamais
   traduit reste dans sa langue (perte constatée par Simon le 01/10, après le passage
   des avis en HTML). On reprend le service de Judge.me — mesuré : CORS ouvert, ~2 s
   pour 3 avis, et la traduction obtenue est ensuite stockée chez Judge.me.

   À traduire : un avis sans mention « Traduit automatiquement » dont la langue n'est
   pas celle de la page. Une langue vide compte pour du français : ce sont les avis
   importés de l'ancien site (40 % du corpus), en français — les traduire vers le
   français ferait une requête inutile par avis sur les pages françaises.
   Rien n'est demandé avant l'approche de la section, comme le widget. */
(function () {
  'use strict';

  var BLOCK_SELECTOR = '[data-wb-reviews]';
  var LIST_SELECTOR = '[data-wb-reviews-list]';
  var ITEM_SELECTOR = '[data-wb-review]';
  var TEMPLATE_SELECTOR = 'template[data-wb-review-template]';
  var STATE_ATTR = 'data-wb-translation'; // pending | done | none | failed
  var API_FALLBACK = 'https://api.judge.me';
  var DEFAULT_REVIEW_LANG = 'fr';
  var BATCH_SIZE = 10;
  var TIMEOUT_MS = 15000;
  var NEAR_MARGIN = '200% 0px';

  function baseLang(code) {
    return String(code || '').toLowerCase().split('-')[0];
  }

  function needsTranslation(li, pageLocale) {
    if (li.hasAttribute(STATE_ATTR) || li.querySelector('.wb-review__translated')) return false;
    var lang = baseLang(li.getAttribute('data-wb-review-lang')) || DEFAULT_REVIEW_LANG;
    return lang !== baseLang(pageLocale);
  }

  function apiUrl(block, uuids, locale) {
    var host = ((window.jdgm || {}).API_HOST || API_FALLBACK).replace(/\/$/, '');
    var params = new URLSearchParams({
      shop_domain: block.getAttribute('data-shop-domain') || '',
      platform: (window.jdgmSettings || {}).platform || 'shopify',
      review_uuids: uuids.join(','),
      language: locale,
      page: '-1', // la valeur que le widget envoie
    });
    return host + '/api/review_translations?' + params.toString();
  }

  function fetchTranslations(url) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, TIMEOUT_MS) : null;
    var options = { headers: { Accept: 'application/json' } };
    if (controller) options.signal = controller.signal;
    return fetch(url, options)
      .then(function (response) {
        if (!response.ok) throw new Error('review_translations : HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        clearTimeout(timer);
        return data || {};
      }, function (error) {
        clearTimeout(timer);
        throw error;
      });
  }

  function setLines(el, text) {
    while (el.firstChild) el.removeChild(el.firstChild);
    text.split('\n').forEach(function (line, i) {
      if (i > 0) el.appendChild(document.createElement('br'));
      el.appendChild(document.createTextNode(line));
    });
  }

  /* La mention « Traduit automatiquement », prise au gabarit de la section : elle est
     déjà dans la langue de la page. */
  function translatedNote(block) {
    var template = block.querySelector(TEMPLATE_SELECTOR);
    var note = template && template.content.querySelector('.wb-review__translated');
    return note ? note.cloneNode(true) : null;
  }

  function apply(block, li, entry) {
    var body = li.querySelector('.wb-review__body');
    var text = entry && entry.body && entry.body.success ? String(entry.body.translated_text || '').trim() : '';
    // Identique à l'original : avis dont Judge.me a mal détecté la langue, rien à montrer.
    if (!body || !text || text === body.textContent.trim()) {
      li.setAttribute(STATE_ATTR, 'none');
      return;
    }
    setLines(body, text);
    var title = li.querySelector('.wb-review__title');
    var titleText = entry.title && String(entry.title.translated_text || '').trim();
    if (title && titleText) title.textContent = titleText;
    var note = translatedNote(block);
    if (note && body.parentNode) body.parentNode.insertBefore(note, body.nextSibling);
    li.setAttribute(STATE_ATTR, 'done');
  }

  function translatePending(block) {
    var locale = block.getAttribute('data-locale') || '';
    var items = Array.prototype.filter.call(
      block.querySelectorAll(LIST_SELECTOR + ' > ' + ITEM_SELECTOR),
      function (li) { return needsTranslation(li, locale); });
    for (var i = 0; i < items.length; i += BATCH_SIZE) {
      var batch = items.slice(i, i + BATCH_SIZE);
      batch.forEach(function (li) { li.setAttribute(STATE_ATTR, 'pending'); });
      translateBatch(block, batch, locale);
    }
  }

  function translateBatch(block, batch, locale) {
    var uuids = batch.map(function (li) { return li.getAttribute('data-wb-review'); });
    fetchTranslations(apiUrl(block, uuids, locale))
      .then(function (data) {
        batch.forEach(function (li) { apply(block, li, data[li.getAttribute('data-wb-review')]); });
      })
      .catch(function () {
        /* Voulu sans message, comme un avis jamais traduit : il reste dans sa langue.
           `failed` évite de le redemander à chaque changement de la liste. */
        batch.forEach(function (li) { li.setAttribute(STATE_ATTR, 'failed'); });
      });
  }

  function whenNear(el, run) {
    if (typeof IntersectionObserver !== 'function') {
      run();
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      run();
    }, { rootMargin: NEAR_MARGIN });
    observer.observe(el);
  }

  function init() {
    var block = document.querySelector(BLOCK_SELECTOR);
    var list = block && block.querySelector(LIST_SELECTOR);
    if (!list) return;
    whenNear(block, function () {
      translatePending(block);
      // « Voir plus », un tri, un filtre ou le remplacement par les plus longs
      // changent la liste : les nouveaux avis sont traduits à leur tour.
      if (typeof MutationObserver === 'function') {
        new MutationObserver(function () { translatePending(block); }).observe(list, { childList: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
